var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',[_c('Attribute',{attrs:{"item":_vm.formatDateRange(),"translate":_vm.attribute.translate}})],1),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.attribute[`label_${_vm.$i18n.locale}`]))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }